<template>
<div class="grid fixed h100" style="grid-template-columns: auto 1fr; grid-template-rows: auto auto;" v-loading="loading">

<!-- <navbar :hotel="hotel" :settings="settings" :ombrelli="ombrelli" :getOmbrelli="getOmbrelli"></navbar> -->
<navbar :hotel="hotel" :settings="settings"></navbar>

<div class="grid cashier h100">
  <div class="grid seasons">
    <!-- <p>{{hotel}}</p> -->
<!--     <div v-if="!hotel.cashier">
      <span><strong>{{hotel.name}} - Stagioni e pagamenti ombrellone</strong></span>
      <div class="spacer sm"></div>
      <p v-if="!hotel.cashier">Al momento non sono state impostate stagioni o pagamenti relativi a ombrelloni o oggetti in spiaggia.</p>
      <p>Abilita questa sezione cliccando sul bottone sottostante.</p>
      <div class="spacer sm"></div>
      <span>
        <el-switch
          v-model="hotel.cashier"
          active-color="#13ce66"
          inactive-color="#ff4949"
          v-on:change="editcashier">
        </el-switch>
      </span>
    </div> -->

    <div class="grid enable">
      <span><strong>{{hotel.name}} - Stagioni e pagamenti ombrellone</strong></span>
      <span>
        <el-switch
          v-model="hotel.cashier"
          active-color="#13ce66"
          inactive-color="#ff4949"
          v-on:change="editcashier">
        </el-switch>
      </span>
      <span>
        <button type="button" v-if="hotel.cashier" class="btn btn-green"  v-on:click="addseason"><i class="fas fa-plus-square"></i> aggiungi stagione</button>
      </span>
    </div>
    <p v-if="hotel && hotel.seasons.length === 0">Aggiungi la tua prima stagione</p>
    <div v-if="hotel.cashier" class="grid season" v-for="(season, index) in hotel.seasons">
      <!-- {{season}}, {{index}} -->
      <span>{{season.name}}</span>
      <div class="grid data">
        <span><small>{{season.start}} > {{season.end}}</small></span>
        <span><small>€ {{season.amount}}</small></span>
        <i class="fas fa-edit" v-on:click="editseason(season, index)"></i>
      </div>
    </div>
    <!-- {{hotel.seasons}} -->
  </div>
  <div class="grid items">
    
    <div class="grid addseason" v-if="newseason || updateseason">
      <span v-if="newseason"><strong>Aggiungi stagione</strong></span>
      <span v-if="updateseason"><strong>Update stagione {{season.name}}</strong></span>
      <!-- <small>{{season}}</small> -->

      <div class="spacer sm"></div>

      <el-form ref="addseasonForm" :model="season" :rules="rules">

        <el-form-item label="Denominazione stagione" prop="name">
            <el-input v-model="season.name" placeholder="Denominazione stagione" name="name"></el-input>
          </el-form-item>
        <div class="spacer xs"></div>
        <el-form-item>
          <el-date-picker
            v-model="season.daterange"
            type="daterange"
            range-separator="al"
            start-placeholder="Start date"
            end-placeholder="End date"
            v-on:change="changeRange()"
            format="dd-MM-yyyy"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Prezzo base ombrellone">
            <el-input v-model="season.amount" placeholder="Prezzo ombrellone" name="ombrellone">
              <template slot="prepend">€</template>
            </el-input>
          </el-form-item>
        <div v-for="item in season.items">
          <!-- <span v-html="item.icon"></span> -->
          <el-form-item :label="'Prezzo base ' + item.name ">
            <el-input v-model="item.price" placeholder="Prezzo oggetto" name="price">
              <template slot="prepend">€</template>
            </el-input>
          </el-form-item>
        </div>
        
          <!-- {{hotel.items}} -->
          <div class="spacer sm"></div>
        <el-form-item>
          <div style="float: right;">
            <el-button class="btn btn-green" v-if="newseason" @click="addnewseason('addseasonForm')">aggiungi stagione</el-button>
            <el-button class="btn btn-secondary" v-if="updateseason" @click="dialogVisible = true"><i class="fas fa-trash"></i></el-button>
            <el-button class="btn btn-green" v-if="updateseason" @click="saveseason('addseasonForm', season.index)">salva impostazioni stagione</el-button>
          </div>
        </el-form-item>

      </el-form>

    </div>

  </div>
</div>

<el-dialog
      title="Attenzione"
      :visible.sync="dialogVisible"
      width="25%">
      <p>Sei sicuro di voler cancellare la stagione {{season.name}}?</p>
      <p>Tutti i dati verranno cancellati.</p>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn-secondary" @click="dialogVisible = false">Anulla</el-button>
        <el-button class="btn btn-red" @click="deleteseason(season.index)">Cancella</el-button>
      </span>
    </el-dialog>
  
</div>
</template>

<script>
  // import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  // import 'moment/locale/de'
  // import 'moment/locale/it'
  const moment = extendMoment(Moment)
  import Navbar from '@/components/Navbar'
  // import Settings from '@/components/Settings'
  var host = process.env.ROOT_API
  export default {
    name: 'pagamenti',
    props: ['auth', 'authenticated'],
    data () {
      return {
        loading: true,
        dialogVisible: false,
        hotel: '',
        newseason: false,
        updateseason: false,
        season: {
          name: '',
          daterange: [],
          items: []
        },
        datePickerOptions: {
          firstDayOfWeek: 1
        },
        rules: {
          name: [
              { required: true, message: 'prego inserisci un nome per la stagione', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      // datepicker,
      Circle4,
      // DateRange,
      'Navbar': Navbar
    },
    sockets: {
      connect: function () {
        // console.log('socket connected')
      },
      stream: function (val) {
        // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        // console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          // console.log('an umbrella was updated')
          // this.getHotel()
        }
      },
      disconnect: function () {
        // console.log('socket error')
        // this.$notify({
        //   group: 'foo',
        //   title: 'Error loading Data',
        //   text: 'I´ll fix it in a few',
        //   type: 'warning',
        //   duration: 5000
        // })
      }
    },
    methods: {
      changeRange () {
        console.log(this.season.daterange)
      },
      editcashier () {
        this.loading = true
        this.$http
          .post(host + '/updateseason', {hotel: this.hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.loading = false
            this.updateseason = false
            this.$notify({
              group: 'foo',
              title: 'Cashier Update',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 5000
            })
          })
      },
      addseason () {
        this.newseason = true
        this.updateseason = false
        // this.season.items = this.hotel.items
        this.season.name = ''
        this.season.items = []
        this.hotel.items.forEach((item, indexo) => {
          this.season.items.push({name: item.name, price: 0})
        })
      },
      editseason (season, index) {
        this.updateseason = true
        this.newseason = false
        this.season = season
        this.season.index = index
        console.log(season)
      },
      addnewseason (formName) {
        console.log('season: ', moment(this.season.daterange[0]).format('YYYY-MM-DD'))
        this.season.start = moment(this.season.daterange[0]).format('YYYY-MM-DD')
        this.season.end = moment(this.season.daterange[1]).format('YYYY-MM-DD')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('addseason')
            this.loading = true
            this.hotel.seasons.push(this.season)
            // this.error.state = false
            this.$http
              .post(host + '/addseason', {hotel: this.hotel},
              {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.jwt
                }
              },
              ).then((data) => {
                console.log(data)
                this.loading = false
                this.season = {}
                this.newseason = false
                this.updateseason = false
                this.$notify({
                  group: 'foo',
                  title: 'Stagione aggiunta',
                  type: 'success',
                  duration: 500
                })
              }, (error) => {
                console.log(error)
                this.loading = false
                this.$notify({
                  group: 'foo',
                  title: 'Error loading Data',
                  text: 'I´ll fix it in a few',
                  type: 'warning',
                  duration: 5000
                })
                // this.error.state = true
                // this.error.message = error.body.error
              })
          } else {
            console.log('error submit!!')
            // return false
          }
        })
      },
      saveseason (formName, index) {
        console.log('season: ', this.season, index)
        this.hotel.seasons[index].start = moment(this.season.daterange[0]).format('YYYY-MM-DD')
        this.hotel.seasons[index].end = moment(this.season.daterange[1]).format('YYYY-MM-DD')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('addseason')
            this.loading = true
            // this.hotel.seasons.push(this.season)
            // this.error.state = false
            this.$http
              .post(host + '/updateseason', {hotel: this.hotel},
              {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.jwt
                }
              },
              ).then((data) => {
                console.log(data)
                this.season = {}
                this.newseason = false
                this.updateseason = false
                this.loading = false
                this.$notify({
                  group: 'foo',
                  title: 'Stagione salvata',
                  type: 'success',
                  duration: 500
                })
              }, (error) => {
                console.log(error)
                this.loading = false
                this.$notify({
                  group: 'foo',
                  title: 'Error loading Data',
                  text: 'I´ll fix it in a few',
                  type: 'warning',
                  duration: 5000
                })
                // this.error.state = true
                // this.error.message = error.body.error
              })
          } else {
            console.log('error submit!!')
            // return false
          }
        })
      },
      deleteseason (index) {
        console.log('season: ', this.season, index)
        this.hotel.seasons.splice(index, 1)
        this.$http
          .post(host + '/updateseason', {hotel: this.hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.loading = false
            this.dialogVisible = false
            this.updateseason = false
            this.$notify({
              group: 'foo',
              title: 'Stagione salvata',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 5000
            })
          })
      },
      getHotel () {
        // console.log('hotelid: ' + this.hotelid)
        // console.log(localStorage)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
          .post(host + '/hotel', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            this.hotel = data.body.hotel
            this.loading = false
            console.log(data)
          }, (error) => {
            console.log(error)
          })
      },
      settings () {
        this.$modal.show('settings')
      }
    },
    beforeMount () {
      // this.getHotel()
    },
    mounted: function () {
      this.getHotel()
      // this.getOverview()
      // moment.locale(this.hotel.lang)
      // console.log('hotel: ', this.hotel)
    },
    computed: {
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Pagamenti.vue?73bf35b7